<template>
  <div class="container">
    <a-form :form="form" @submit.prevent="handleSubmit" autocomplete="off">
      <div class="flex flex-col md:flex-row">
        <div class="w-full">
            <div class="flex flex-col-reverse md:flex-row md:justify-between">

              <div class="self-center profile-mobile">
                <p class="my-5 text-sm font-medium">
                  Which Type of Contact do you want to create?
                </p>
                <span class="space-x-2 flex">
                    <vs-button color="primary" type="border" icon="person" class="font-bold" @click="isPerson">Person</vs-button>
                    <vs-button color="primary" type="border" icon="apartment" class="font-bold" @click="iscompany">Company</vs-button>
                  </span>
              </div>

              <div class="mt-3 flex flex-col self-center">
                <Xupload class="profile-photo" url="/storage/public/" ref="contact" :rows="rows" @input="profileUser"/>
                <p class="font-bold text-base profile">Profile Photo</p>
              </div>

            </div>
        </div>
      </div>
      <a-divider/>
      <div class="flex flex-col md:flex-row">
        <div class="w-full">
            <div class="grid sm:grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-4">
              <template v-if="!isCompanyClicked">
                <a-auto-complete>
                  <a-form-item label="FirstName" has-feedback>
                    <a-input
                      v-decorator="['person.first_name',{ rules: [{ required: true, message: 'Please input your First name!' }] }]"
                      placeholder="FirstName"
                      autocomplete="none"
                    />
                  </a-form-item>
                </a-auto-complete>
                <a-form-item label="LastName" has-feedback>
                  <a-input
                    autocomplete="none"
                    v-decorator="['person.last_name',{ rules: [{ required: true, message: 'Please input your Last name!' }] }]"
                    placeholder="LastName"
                  />
                </a-form-item>
                <a-form-item label="MiddleName" has-feedback>
                  <a-input
                    v-decorator="['person.middle_name',{ initialValue:null,rules: [{ required: false }] }]"
                    placeholder="MiddleName"
                    autocomplete="none"
                  />
                </a-form-item>
                <a-form-item label="Prefix" has-feedback>
                  <a-input
                    v-decorator="['person.prefix',{ initialValue:null,rules: [{ required: false }] }]"
                    placeholder="prefix"
                    autocomplete="none"
                  />
                </a-form-item>
              </template>
              <template v-else>
                <a-form-item label="Company" has-feedback>
                  <a-input
                    v-decorator="['company.name',{ initialValue:null,rules: [{ required: true, message: 'Please input your company' }] }]"
                    placeholder="company"
                    autocomplete="none"
                  />
                </a-form-item>
              </template>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="flex flex-col">
                <a-form-item label="Email" has-feedback>
                  <a-input
                    autocomplete="none"
                    v-decorator="[`emails[0].email_address`,{initialValue: null , rules: [{ required:false,message: 'Please input your Email address!' },{ pattern:/([a-zA-Z0-9]+)([\_\.\-{1}])?([a-zA-Z0-9]+)\@([a-zA-Z0-9]+)([\.])([a-zA-Z\.]+)/,type:'string', required: false,message: 'format email is invalid.' }] }]"
                    placeholder="example@gmail.com"
                    class="w-full"
                  />
                </a-form-item>
                <a-form-item has-feedback class="mt-5">
                  <a-select
                    v-decorator="[`emails[0].email_type`,{initialValue: 0 , rules: [{ required: true, message: 'Please input your type email!' }] }]"
                    placeholder="Type"
                    class="country"
                    show-search
                    allowClear
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="0">
                      Work
                    </a-select-option>
                    <a-select-option :value="1">
                      Person
                    </a-select-option>
                    <a-select-option :value="2">
                      Other
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="flex flex-col">
                <a-form-item label="website" has-feedback>
                  <a-input autocomplete="none" class="website" placeholder="www.mysite.com" v-decorator="
                          [`websites[0].website_address`,
                            {
                              initialValue:null,
                              rules: [
                                {
                                    required: false,
                                    message: 'Please input your website'
                                },
                                {
                                    pattern:/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                    type: 'string',
                                    message:'format website is invalid.',
                                    required: false
                                }
                            ]
                           }
                      ]" style="border-radius: 3px !important;"/>
                </a-form-item>
                <a-form-item class="mt-5" has-feedback>
                  <a-select
                    v-decorator="[`websites[0].website_type`,{initialValue: 0 , rules: [{ required: true, message: 'Please input your type website!' }] }]"
                    placeholder="Type"
                    class="country"
                    show-search
                    allowClear
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="0">
                      Work
                    </a-select-option>
                    <a-select-option :value="1">
                      Personal
                    </a-select-option>
                    <a-select-option :value="2">
                      FaceBook
                    </a-select-option>
                    <a-select-option :value="3">
                      Linkedin
                    </a-select-option>
                    <a-select-option :value="4">
                      Twitter
                    </a-select-option>
                    <a-select-option :value="5">
                      Instant messager
                    </a-select-option>
                    <a-select-option :value="6">
                      Other
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="flex flex-col">
                <a-form-item label="Phone Number" has-feedback>
                  <a-input
                    autocomplete="none"
                    v-decorator="[`phones[0].phone_number`,
                                {
                                  initialValue:null,
                                  rules: [
                                    {
                                      required: false,
                                      message: 'Please input your Phone number!'
                                    },
                                    {
                                      pattern:/^[0-9]*$/,
                                      type:'string',
                                      message: 'Phone number only contain numbers.',
                                      required:false,
                                    },
                                    // {
                                    //   len: 11,
                                    //   message: 'Phone number must be less than 11 digits',
                                    //   required:false
                                    // },
                                ],
                               },
                        ]"
                    placeholder="Phone Number"
                    class="number_phone"
                  />
                </a-form-item>
                <a-form-item has-feedback class="mt-5">
                  <a-select
                    v-decorator="[`phones[0].phone_type`,{initialValue: 0 , rules: [{ required: true, message: 'Please input your type phone!' }] }]"
                    placeholder="Type"
                    class="country"
                    show-search
                    allowClear
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="0">
                      Work
                    </a-select-option>
                    <a-select-option :value="1">
                      Home
                    </a-select-option>
                    <a-select-option :value="2">
                      Mobile
                    </a-select-option>
                    <a-select-option :value="3">
                      Pager
                    </a-select-option>
                    <a-select-option :value="4">
                      Skype
                    </a-select-option>
                    <a-select-option :value="5">
                      Other
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </div>
        </div>
      </div>
      <a-divider/>
      <div class="flex flex-col md:flex-row scoll_bottom">
        <div class="w-full">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <a-form-item label="Country" has-feedback>
                    <a-select
                      v-decorator="[`addresses[0].country`,{ initialValue:null,rules: [{ required: false }] }]"
                      placeholder="Country"
                      class="country"
                      allowClear
                      show-search
                      autocomplete="none"
                      :filter-option="filterOption"
                    >
                      <a-icon slot="suffixIcon" type="search" />
                      <a-select-option v-for="city in cities" :value="city.id">
                        {{ city.name }} ({{ city.code }})
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="City" has-feedback>
                    <a-input
                      v-decorator="[`addresses[0].city`,{initialValue:null,rules: [{ required: false }] }]"
                      placeholder="City"
                      autocomplete="none"
                    />
                  </a-form-item>
                  <a-form-item label="State" has-feedback>
                    <a-input
                      v-decorator="[`addresses[0].state`,{ initialValue:null,rules: [{ required: false }] }]"
                      autocomplete="none"
                    />
                  </a-form-item>
                  <a-form-item label="PostCode" has-feedback>
                    <a-input
                      v-decorator="[`addresses[0].post_code`,
                      {
                        initialValue:null,rules: [{ required: false }],
                      },
                    ]"
                      autocomplete="none"
                      class="number_phone"
                    />
                  </a-form-item>
                </div>
            <a-form-item label="Street" has-feedback>
                  <a-textarea
                    v-decorator="[`addresses[0].street`,{ initialValue:null,rules: [{ required: false }] }]"
                    autocomplete="none"
                  />
                </a-form-item>
        </div>
      </div>

      <a-divider/>

      <span class="flex space-x-2">
        <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">Save</a-button>
        <a-button type="primary" @click="onCancelAddClient" ghost style="border-radius: 3px !important;">Cancel</a-button>
      </span>

    </a-form>
  </div>
</template>

<script>

import Xupload from '../../components/x-upload/XUpload'
import axios from '@/axios'
import Mixin from '../mixin/mixin'

export default {
  name: "ContactAdd",
  mixins: [Mixin],
  components:{
    Xupload
  },
  data(){
    return{
      imageUrl: '',
      loading: false,
      isCompanyClicked:false,
      cities:[],
      emails:[{id:null,email_address:null,email_type: 0}],
      sites:[{id:null,website_address:null,website_type: 0}],
      addresses:[{id:null,country:null,city: null,state:null,street:null,post_code:null,address_type:0}],
      temp:2,
      rows:{},
      phonies:[{id:null,phone_number:null,phone_type: 0}],
      st:null,
      profileSrc: null,
      fetching:false,
    }
  },
  methods:{

    onCancelAddClient(){
      this.$emit('cancelClick')
    },

    handleSubmit() {
      this.form.validateFields(async(err, values) => {
        if(!this.isCompanyClicked){
          if(!values.person.first_name){
            this.$message.error('Filling in the FirstName is required.');
            window.scroll({ top: 0, behavior: 'smooth' });
            return
          }
          if(!values.person.last_name){
            this.$message.error('Filling in the LastName is required.');
            window.scroll({ top: 0, behavior: 'smooth' });
            return
          }
        }else {
          if(!values.company.name){
            this.$message.error('Filling in the Company is required.');
            window.scroll({ top: 0, behavior: 'smooth' });
            return
          }
        }
        if (!err) {
          try{
            this.$vs.loading()
            this.profileSrc ? values.avatar_url = this.profileSrc : values.avatar_url = this.rows.avatar_url
            if((values.emails[0].email_address==null || values.emails[0].email_address=="")  && values.emails.length == 1){
              values.emails = []
            }
            if((values.phones[0].phone_number==null || values.phones[0].phone_number=="")  && values.phones.length == 1){
              values.phones = []
            }
            if((values.websites[0].website_address==null || values.websites[0].website_address=="") && values.websites.length == 1){
              values.websites = []
            }
            if(!values.addresses[0].country && !values.addresses[0].city && !values.addresses[0].state && !values.addresses[0].post_code && !values.addresses[0].street && values.addresses.length == 1){
              values.addresses = []
            }
            const {data} = await axios.post('contact/', values)
            this.$notification['success']({
              message: 'Success',
              description: 'Client Created.'
            });
            this.$emit('addClient',data)
            this.form.resetFields()
          }catch (e) {
            this.$notification['error']({
              message: 'Error',
              description: 'Server Error'
            })
            throw e
          }finally {
            this.$vs.loading.close()
          }

        }
      });
    },

    iscompany(){
      this.isCompanyClicked = true
    },

    isPerson(){
      this.isCompanyClicked = false
    },

    async getCity(){
      const { data } = await axios.post('/dictionary/country/')
      this.cities = data
    },

    profileUser(src){
      this.profileSrc = src
    }

  },

  mounted() {
    this.getCity()
  },
  created() {
    if(this.$route.query.type) {
      if(this.$route.query.type === 'person' || this.$route.query.type === 'company')
        this.$route.query.type === "person" ? this.isCompanyClicked = false : this.isCompanyClicked = true
      else
        this.$router.push({ path: '/contacts/add', query: { type: 'person' }})
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }

}
</script>

<style>

.container{
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

[dir] .ant-divider{
  /*background: #ccc !important;*/
}

[dir] .ant-input{
  border-radius: 3px !important;
}

.profile{
  margin-bottom: 0 !important;
}

.number_phone .ant-input{
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.number_phone .ant-input-group-addon{
  border-radius: 3px;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.website {
  /*margin-bottom: 4px !important;*/
}

.website .ant-input-group-addon{
  border-radius: 3px;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.website .ant-input{
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.website_domain .ant-select-selection.ant-select-selection--single{
  border-top-right-radius: 3px !important;
  border-bottom-right-radius: 3px !important;
}

.country .ant-select-selection.ant-select-selection--single{
  border-radius: 3px !important;
}

.minus{
  padding-top: 1em;
  text-align: right;
  width: 25px;
  display: block;
  margin-left: auto;
}

.feather-minus-circle:hover{
  color:#ff2424 !important;
}

.minus{
  cursor: pointer;
  transition: 0.5s cubic-bezier(0.71, 0.63, 0, 1.29);
  transform: translateY(0);
}

.plus-icon,.minus-address{
  margin-top: 1em;
  cursor: pointer;
  transition: 0.5s cubic-bezier(0.71, 0.63, 0, 1.29);
  transform: translateY(0);
}

.plus-icon:hover,.minus:hover,.minus-address:hover{
  transition: 0.5s cubic-bezier(0.71, 0.63, 0, 1.29);
  transform: translateY(-3px);
}

.slide-enter-active {
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;
  -webkit-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.email .ant-form-explain,.site .ant-form-explain , .phone .ant-form-explain{
  position: absolute;
  /*bottom: 20px;*/
}

.vs-card--content,.con-vs-card{
  margin-bottom: 0 !important;
}

.minus-address{
  /*margin-bottom: 2em;*/
  text-align: end;
  display: block;
}

.ant-message{
  z-index: 1000000000000;
}

.minus-website{
  margin-left: auto;
  display: block;
  text-align: end;
}

[dir] .ant-upload.ant-upload-select-picture-card{
  /*border-radius: 50% !important;*/
}

.profile-photo .ant-upload.ant-upload-select-picture-card > .ant-upload{
  display: flex;
  justify-content: center;
  align-items: center;
}

.has-success.has-feedback .ant-form-item-children-icon {
  /*color: #3A3DBE !important;*/
  /*z-index: 0;*/
}


.slide-up-enter-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-up-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);

}
.slide-up-enter, .slide-fade-leave-to {
  transform: translateY(10vh);
  opacity: 0;
}

.slide-up-enter-to, .slide-up-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-up-enter, .slide-up-leave-to {
  overflow: hidden;
  max-height: 0;
}

[dir=ltr] .ant-btn.ant-btn-primary{
  margin-right: 0 !important;
}



</style>
